<template>
  <form class="list-type-form" @submit.prevent="submit">
    <Field
      label="List Type Slug"
      placeholder="the-best-widget-ever"
      @input="$v.resource.name.$touch()"
      v-model="resource.name"
      :error="nameError"/>

    <Field
      label="Allow many items?"
      type="checkbox"
      @input="$v.resource.allow_many_items.$touch()"
      v-model="resource.allow_many_items"
      helpText="Should this list allow many items inside of it? E.g. a slideshow"/>

    <btn primary>Save Changes</btn>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'ListTypeForm',

  mixins: [form],

  computed: {
    ...errorMessages([
      'name', 'allow_many_items'
    ])
  },

  components: {
    Btn
  },

  validations: {
    resource: {
      name: {required}
    }
  }
}
</script>

<style lang="sass">
</style>
